import axios from "axios";
import config from "../../config.json";

export const updateSubcategoriesOrder = async (categoryId, orders) => {
  const token = localStorage.getItem("tokenLogin");
  const res = await axios.put(
    `${config.dev}/v2/categories/${categoryId}/subcategories/order`,
    { orders },
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }
  );
  return res.data;
};
